module.exports = __webpack_public_path__ + "static/media/futbol.62df6e39.svg";